import type { RouteObject } from "react-router-dom";
import { helperPathname, pathname } from "#src/config/pathname";

import AccountSettingPage from "#src/pages/accountSettings";
import NotificationSettingPage from "#src/pages/accountSettings/notification";

export const accountRoute: RouteObject = {
  path: helperPathname.ACCOUNT,
  children: [
    {
      path: pathname.ACCOUNT_SETTINGS,
      element: <AccountSettingPage />,
    },
    {
      path: pathname.NOTIFICATION,
      element: <NotificationSettingPage />,
    },
  ],
};
